import { createApp } from 'vue'
import Statistics from './Statistics.vue'
import './assets/global.css'

createApp(Statistics).mount('#statistics')
